"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));

/**
 * The result of dump.js is a big JSON tree
 * which can be easily serialized (for instance
 * to be sent from a webworker to the main app
 * or through Node's IPC), but we want
 * a (circular) DOM-like interface for walking
 * through the data.
 *
 * @fileoverview DOM-like interface for walking through data
 * @author Kevin Kwok <antimatter15@gmail.com>
 * @author Guillermo Webster <gui@mit.edu>
 * @author Jerome Wu <jeromewus@gmail.com>
 */
module.exports = function (iPage) {
  var page = (0, _extends2.default)({}, iPage, {
    paragraphs: [],
    lines: [],
    words: [],
    symbols: []
  });
  page.blocks.forEach(function (iBlock) {
    var block = (0, _extends2.default)({}, iBlock, {
      page: page,
      lines: [],
      words: [],
      symbols: []
    });
    block.paragraphs.forEach(function (iPara) {
      var para = (0, _extends2.default)({}, iPara, {
        block: block,
        page: page,
        words: [],
        symbols: []
      });
      para.lines.forEach(function (iLine) {
        var line = (0, _extends2.default)({}, iLine, {
          paragraph: para,
          block: block,
          page: page,
          symbols: []
        });
        line.words.forEach(function (iWord) {
          var word = (0, _extends2.default)({}, iWord, {
            line: line,
            paragraph: para,
            block: block,
            page: page
          });
          word.symbols.forEach(function (iSym) {
            var sym = (0, _extends2.default)({}, iSym, {
              word: word,
              line: line,
              paragraph: para,
              block: block,
              page: page
            });
            sym.line.symbols.push(sym);
            sym.paragraph.symbols.push(sym);
            sym.block.symbols.push(sym);
            sym.page.symbols.push(sym);
          });
          word.paragraph.words.push(word);
          word.block.words.push(word);
          word.page.words.push(word);
        });
        line.block.lines.push(line);
        line.page.lines.push(line);
      });
      para.page.paragraphs.push(para);
    });
  });
  return page;
};